<div class="main-content ajustes-page cc-pagina cc-config">
  <div class="container-fluid">
    <nav class="cc-migas" aria-label="Ruta de navegación">
      <a [routerLink]="rutaTablero">Calidad de código</a>
      <span aria-hidden="true">›</span>
      <span aria-current="page">Configuración</span>
    </nav>

    <section class="ajustes-hero cc-config__hero">
      <div class="ajustes-hero__identity">
        <span class="cc-config__icono" aria-hidden="true">
          <i class="material-icons">tune</i>
        </span>
        <div class="ajustes-hero__content">
          <h1>Configuración</h1>
          <p class="ajustes-hero__role">Conexión con SonarQube, sincronización y cómo se muestra cada proyecto</p>
          <div class="ajustes-hero__meta cc-config__datos" *ngIf="chips.length > 0">
            <span class="cc-insignia" *ngFor="let c of chips" [ngClass]="c.clase">
              <span class="material-icons" aria-hidden="true">{{ c.icono }}</span>
              {{ c.texto }}
            </span>
          </div>
        </div>
      </div>
      <div class="cc-config__acciones">
        <a class="app-form-btn app-form-btn--secondary app-form-btn--compact" [routerLink]="rutaTablero">Tablero</a>
        <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact" *ngIf="conexion"
                [disabled]="sincronizando || !conexion.configurada" [attr.aria-busy]="sincronizando" (click)="sincronizar()">
          <span class="material-icons" aria-hidden="true">sync</span>
          {{ sincronizando ? "Sincronizando…" : "Sincronizar ahora" }}
        </button>
      </div>
    </section>

    <!-- Lo que deja guardar o sincronizar va como flotante arriba a la derecha (flotantes/). -->

    <section class="ajustes-card" *ngIf="loading">
      <div class="ajustes-card__body cc-vacio">
        <span class="material-icons" aria-hidden="true">hourglass_top</span>
        <h3>Consultando la configuración</h3>
        <p>Espere un momento.</p>
      </div>
    </section>

    <section class="ajustes-card" *ngIf="!loading && error">
      <div class="ajustes-card__body cc-vacio">
        <span class="material-icons" aria-hidden="true">{{ sinPermiso ? "lock" : "lock_outline" }}</span>
        <h3>{{ sinPermiso ? "Esta pantalla es del perfil de Administración" : "No se pudo consultar la configuración" }}</h3>
        <p>{{ error }}</p>
        <div class="cc-vacio__acciones">
          <a class="app-form-btn app-form-btn--secondary app-form-btn--compact" [routerLink]="rutaTablero">Ir al tablero</a>
          <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" *ngIf="!sinPermiso" (click)="consultar()">
            Volver a consultar
          </button>
        </div>
      </div>
    </section>

    <div class="row ajustes-layout cc-config__rejilla" *ngIf="!loading && !error && conexion">
      <!-- ============================ Conexión y bitácora ============================ -->
      <div class="col-12 col-xl-6 cc-config__izquierda">
        <section class="ajustes-card" aria-labelledby="cc-config-conexion">
          <div class="ajustes-card__header cc-config__encabezado">
            <div class="ajustes-card__title">
              <i class="material-icons" aria-hidden="true">hub</i>
              <h2 id="cc-config-conexion">Conexión con SonarQube</h2>
            </div>
          </div>
          <div class="ajustes-card__body cc-config__cuerpo">
            <dl class="cc-config__conexion">
              <div *ngFor="let d of datosConexion" [ngClass]="'is-' + d.tono">
                <dt>{{ d.rotulo }}</dt>
                <dd>
                  <span class="cc-config__punto" aria-hidden="true"></span>
                  <a class="cc-enlace" *ngIf="d.enlace; else valorPlano" [href]="d.enlace" target="_blank" rel="noopener">{{ d.valor }}</a>
                  <ng-template #valorPlano><span>{{ d.valor }}</span></ng-template>
                </dd>
              </div>
            </dl>
            <p class="cc-config__nota cc-sec">
              Las propiedades cos.sonar.* viven en el archivo de configuración del servidor; el valor de la credencial nunca
              se enseña.
            </p>
          </div>
        </section>

        <section class="ajustes-card" aria-labelledby="cc-config-bitacora">
          <div class="ajustes-card__header cc-config__encabezado">
            <div class="ajustes-card__title">
              <i class="material-icons" aria-hidden="true">history</i>
              <h2 id="cc-config-bitacora">Últimas sincronizaciones</h2>
            </div>
            <span class="cc-sec cc-config__encabezado-nota">{{ textoBitacora }}</span>
          </div>
          <div class="ajustes-card__body cc-config__cuerpo cc-config__bitacora-cuerpo">
            <div class="table-page cc-config__tabla-marco" *ngIf="bitacora.length > 0; else sinBitacora">
              <div class="table-page__table-wrap">
                <table class="table-page__table cc-config__bitacora">
                  <caption class="cc-oculto">Las últimas pasadas de sincronización con SonarQube.</caption>
                  <thead>
                    <tr>
                      <th scope="col">Inicio</th>
                      <th scope="col">Origen</th>
                      <th scope="col" class="cc-config__num" title="Duración">Dur.</th>
                      <th scope="col" class="cc-config__num" title="Análisis nuevos guardados">Nuevos</th>
                      <th scope="col" class="cc-config__num" title="Cambios detectados sin análisis nuevo">Cambios</th>
                      <th scope="col" class="cc-config__num" title="Llamadas a SonarQube">Llam.</th>
                      <th scope="col">Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let b of bitacora; let i = index; trackBy: trackBitacora" class="cc-entra" [style.animation-delay.ms]="i * 20">
                      <td class="cc-num cc-config__fecha">{{ b.inicio }}</td>
                      <td class="cc-config__origen" [attr.title]="b.origen">{{ b.origen }}</td>
                      <td class="cc-num cc-config__num">{{ b.duracion }}</td>
                      <td class="cc-num cc-config__num">{{ b.nuevos }}</td>
                      <td class="cc-num cc-config__num">{{ b.cambios }}</td>
                      <td class="cc-num cc-config__num">{{ b.llamadas }}</td>
                      <td>
                        <span class="cc-insignia" [ngClass]="b.estado.clase" [attr.title]="b.error || b.estado.texto">
                          <span class="material-icons" aria-hidden="true">{{ b.estado.icono }}</span>
                          {{ b.estado.texto }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <ng-template #sinBitacora>
              <p class="cc-config__nota cc-sec">Todavía no ha corrido ninguna sincronización.</p>
            </ng-template>
          </div>
        </section>
      </div>

      <!-- ============================ Proyectos ============================ -->
      <div class="col-12 col-xl-6">
        <section class="ajustes-card cc-config__proyectos" aria-labelledby="cc-config-proyectos">
          <div class="ajustes-card__header cc-config__encabezado">
            <div class="ajustes-card__title">
              <i class="material-icons" aria-hidden="true">folder_special</i>
              <h2 id="cc-config-proyectos">Proyectos</h2>
            </div>
            <span class="cc-sec cc-config__encabezado-nota">{{ proyectos.length }} en SonarQube · se guarda uno por uno</span>
          </div>
          <div class="ajustes-card__body cc-config__cuerpo cc-config__maestro">
            <ul class="cc-config__lista" aria-label="Proyectos">
              <li *ngFor="let p of proyectos; let i = index; trackBy: trackProyecto" class="cc-entra" [style.animation-delay.ms]="i * 20">
                <button type="button" class="cc-config__opcion" [class.is-elegido]="p.id === edicion?.id"
                        [attr.aria-current]="p.id === edicion?.id ? 'true' : null" (click)="elige(p)">
                  <span class="cc-config__opcion-nombre" [attr.title]="p.nombre">{{ p.nombre }}</span>
                  <span class="cc-etiqueta" *ngIf="p.etiqueta">{{ p.etiqueta }}</span>
                  <span class="cc-marca is-neutro" *ngIf="p.mostrar === false">oculto</span>
                </button>
              </li>
            </ul>

            <form class="cc-config__forma" *ngIf="edicion as e" (ngSubmit)="guardar()">
              <div class="cc-config__forma-encabezado">
                <strong class="cc-fuerte">{{ e.nombre }}</strong>
                <span class="cc-sec cc-mono cc-config__clave" [attr.title]="e.clave">{{ e.clave }}</span>
              </div>

              <mat-slide-toggle class="cc-config__mostrar" name="mostrar" [(ngModel)]="e.mostrar" [disabled]="guardando">
                Mostrar en el tablero
              </mat-slide-toggle>

              <div class="cc-config__campos">
                <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
                  <mat-label>Etiqueta</mat-label>
                  <input matInput id="cc-config-etiqueta" name="etiqueta" aria-label="Etiqueta" [maxlength]="largoEtiqueta"
                         title="Junto al nombre en el tablero, p. ej. «Prueba»" [(ngModel)]="e.etiqueta" [disabled]="guardando" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
                  <mat-label>Umbral de días</mat-label>
                  <input matInput id="cc-config-dias" name="dias" type="number" min="1" max="3650" aria-label="Umbral de días"
                         title="Días sin analizarse para marcarlo como desactualizado; vacío: el valor global del servidor (30)"
                         [(ngModel)]="e.diasDesactualizado" [disabled]="guardando" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="table-page__field cc-config__ancho" subscriptSizing="dynamic">
                  <mat-label>Azure DevOps (URL de la colección)</mat-label>
                  <input matInput id="cc-config-azure" name="azureUrl" aria-label="Azure DevOps (URL de la colección)"
                         [(ngModel)]="e.azureUrl" [disabled]="guardando" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
                  <mat-label>Proyecto Azure</mat-label>
                  <input matInput id="cc-config-proyecto" name="azureProyectoId" aria-label="Proyecto Azure"
                         [(ngModel)]="e.azureProyectoId" [disabled]="guardando" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
                  <mat-label>Repositorio</mat-label>
                  <input matInput id="cc-config-repo" name="azureRepoId" aria-label="Repositorio"
                         title="El repositorio de Azure DevOps donde vive el código" [(ngModel)]="e.azureRepoId" [disabled]="guardando" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
                  <mat-label>Pipeline Sonar</mat-label>
                  <input matInput id="cc-config-def" name="azureDefSonar" type="number" min="1" aria-label="Pipeline Sonar"
                         title="El número de la definición del pipeline que analiza" [(ngModel)]="e.azureDefSonar" [disabled]="guardando" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
                  <mat-label>Rama real</mat-label>
                  <input matInput id="cc-config-rama" name="ramaReal" aria-label="Rama real" title="SonarQube Community lleva una sola rama"
                         [(ngModel)]="e.ramaReal" [disabled]="guardando" />
                </mat-form-field>
              </div>
              <p class="cc-config__nota cc-sec">
                Con URL, proyecto y repositorio de Azure se arma el enlace al commit de cada análisis; sin días, aplica el
                global del servidor (30).
              </p>

              <div class="cc-config__forma-pie">
                <span class="cc-sec cc-config__sin-cambios" *ngIf="!conCambios">Sin cambios por guardar</span>
                <div class="cc-config__forma-botones">
                  <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" [disabled]="!conCambios || guardando"
                          (click)="descartar()">Descartar</button>
                  <button type="submit" class="app-form-btn app-form-btn--primary app-form-btn--compact" [disabled]="!conCambios || guardando"
                          [attr.aria-busy]="guardando">{{ guardando ? "Guardando…" : "Guardar" }}</button>
                </div>
              </div>
            </form>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>
